<template>
  <div class="nuttrema-status-label" :class="[`nuttrema-status--${status}`, { 'is-shown': show }]">
    <div class="nuttrema-status-label__toggler">
      <button-resize-toggler
         class="is-on-top"
         vertical-correction="(100% - 0.5em - 36px) / 2"
        @click="show = !show"
        :collapsed="show">
      </button-resize-toggler>
    </div>
    <template v-if="show">
    <div class="nuttrema-status-label__status">
        <div class="status__description">
          <div class="description__title">{{ $t('label.status') }}</div>
          <div class="description__value">{{ $t(`label.${status}`) }}</div>
        </div>
        <div class="status__action">
          <el-popover
             ref="statusInfo"
             placement="top"
             width="340"
             trigger="click"
             popper-class="el-popover--status"
            :title="$t('label.status')">
            <template v-for="status in available">
              <p style="margin-bottom: 0.5em"><strong>{{ $t(`label.${status}`) }}</strong>: {{ $t(`label.status_${related}_${status}_help`) }}</p>
            </template>
          </el-popover>

          <template v-if="link">
            <el-button-group>
              <el-button size="mini" type="primary" v-popover:statusInfo><i class="fas fa-info"></i></el-button>
              <el-button size="mini" type="primary" @click="onChangeStatus">{{ $t('label.status_details') }} <i class="fas fa-chevron-right"></i></el-button>
            </el-button-group>
          </template>
          <template v-else>
            <el-button size="mini" type="primary" v-popover:statusInfo><i class="fas fa-info"></i></el-button>
          </template>
        </div>
    </div>
    </template>
    <template v-else>
      <el-tooltip class="item" effect="dark" :content="$t(`label.${status}`)" placement="top-end">
        <div class="nuttrema-status-label__status as-link" @click="show = !show"></div>
      </el-tooltip>
    </template>
  </div>
</template>

<script>
import ButtonResizeToggler from 'components/ui/button/button-resize-toggler';
import NuttremaStatusTag from './nuttrema-status-tag';

export default {
  name: 'nuttrema-status-label',
  mixins: [NuttremaStatusTag],
  components: {
    ButtonResizeToggler,
  },
};
</script>

<style lang="scss" scoped>
  @import "./nuttrema-status-colors";

  .nuttrema-status-label {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0.5em 0.75em;

    .nuttrema-status-label__toggler {
      height: 1em;
      display: flex;
      position: relative;
      align-items: center;
      justify-content: center;
    }

    .nuttrema-status-label__status {
      display: flex;
      justify-content: space-between;
      border-radius: 0.25em;
      background-color: gray;
      color: #fff;
      padding: 0.25em;

      .status__description {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        .description__title {
          font-size: 0.75rem;
          text-transform: uppercase;
        }
        .description__value {
          font-weight: 600;
          line-height: 1.15;
          font-size: 1.15rem;
          margin-top: -0.15em;
        }
      }

      .status__action {
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }

      &.as-link:hover {
        cursor: pointer;
      }
    } // end ~ nuttrema-status-tag__status

    &.is-shown {
      .nuttrema-status-label__status {
        padding: 0.35em 0.4em ;
        background-color: $color-gray-dark;
      }
    }

    &.nuttrema-status--draft {
      .nuttrema-status-label__status {
        background-color: $color-status-draft;
      }
      /deep/ .button-resize-toggler {
        &:before, &:after {
          background-color: $color-status-draft;
        }
      }
    }

    &.nuttrema-status--pending {
      .nuttrema-status-label__status {
        background-color: $color-status-pending;
      }
      /deep/ .button-resize-toggler {
        &:before, &:after {
          background-color: $color-status-pending;
        }
      }
    }

    &.nuttrema-status--active {
      .nuttrema-status-label__status {
        background-color: $color-status-active;
      }
      /deep/ .button-resize-toggler {
        &:before, &:after {
          background-color: $color-status-active;
        }
      }
    }

    &.nuttrema-status--inactive {
      .nuttrema-status-label__status {
        background-color: $color-status-inactive;
      }
      /deep/ .button-resize-toggler {
        &:before, &:after {
          background-color: $color-status-inactive;
        }
      }
    }

    &.nuttrema-status--archived {
      .nuttrema-status-label__status {
        background-color: $color-status-archived;
      }
      /deep/ .button-resize-toggler {
        &:before, &:after {
          background-color: $color-status-archived;
        }
      }
    }

    &.nuttrema-status--accepted {
      .nuttrema-status-label__status {
        background-color: $color-status-accepted;
      }
      /deep/ .button-resize-toggler {
        &:before, &:after {
          background-color: $color-status-accepted;
        }
      }
    }

  } // end ~ nuttrema-status-label
</style>



// WEBPACK FOOTER //
// src/components/ui/label/nuttrema-status-label.vue